const jsonSchema = [
  {
    name: 'global',
    label: 'Global',
    type: 'checkbox',
    required: 'false',
    hidden: true
  },
  {
    type: 'group',
    fields: [
      {
        name: 'date',
        label: 'Date',
        type: 'date',
        required: false,
        notEditable: false,
        pattern: 'YYYY-MM-DD',
        showInList: true
      },
      {
        name: 'source',
        label: 'Source',
        type: 'text',
        showInList: true
      }
    ]
  },

  {
    type: 'group',
    fields: [
      {
        name: 'name',
        label: 'Name',
        type: 'text',
        required: true,
        showInList: true
      },
      {
        name: 'type',
        label: 'Type',
        type: 'multiselect',
        options: [],
        required: true,
        showInList: true
      }
    ]
  },

  {
    type: 'group',
    fields: [
      {
        name: 'exercises',
        label: 'Exercises',
        type: 'creatableselect',
        required: false,
        showInList: false,
        isMulti: true
      },
      {
        name: 'tags',
        label: 'Tags',
        type: 'creatableselect',
        required: false,
        showInList: false,
        isMulti: true
      }
    ]
  },
  {
    name: 'fullWarmUp',
    label: 'Warm Up',
    type: 'editor',
    required: false,
    showInList: false
  },
  {
    name: 'strength',
    label: 'Strength',
    type: 'editor',
    required: false,
    showInList: false
  },
  {
    name: 'workout',
    label: 'Metcon',
    type: 'editor',
    required: false,
    showInList: false
  },
  {
    name: 'modifications',
    label: 'Modifications',
    type: 'editor',
    required: false,
    showInList: false
  },
  {
    name: 'coolDown',
    label: 'Cool Down',
    type: 'editor',
    required: false,
    showInList: false
  },
  {
    name: 'description',
    label: 'Description',
    type: 'editor',
    required: false,
    showInList: false
  }

  // Add more fields as needed
];
export default jsonSchema;
